import { API_GET_LIST_FOLLOW_COLUMN_SUCCESS, API_GET_ONE_COLUMN_SUCCESS, } from '../actions/ColumnActions';
const initialState = {
    follows: {},
    one: {},
};
// eslint-disable-next-line default-param-last
export default (state = initialState, { meta, payload, type }) => {
    switch (type) {
        case API_GET_ONE_COLUMN_SUCCESS: {
            return Object.assign(Object.assign({}, state), { one: Object.assign(Object.assign({}, state.one), { [payload.urlCode]: payload }) });
        }
        case API_GET_LIST_FOLLOW_COLUMN_SUCCESS: {
            return Object.assign(Object.assign({}, state), { follows: Object.assign(Object.assign({}, state.follows), { [meta.urlCode]: payload.list }) });
        }
        default: {
            return state;
        }
    }
};
